{
  "title": "Testeur de configuration",
  "subtitle": "Ce qui est réellement vrai sur le chemin de messagerie de ce locataire, et ce que personne n’a encore vérifié.",
  "loadError": "Impossible de charger les résultats des tests",
  "runChecks": "Lancer les contrôles",
  "pass": "Réussi",
  "fail": "Échoué",
  "skip": "Non exécuté",
  "warn": "Avertissement",
  "ignored": "Ignoré",
  "history": "Historique des exécutions",
  "pasteReport": "Coller un rapport",
  "pasteHint": "Collez la sortie de Test-TenantMailFlow.ps1 pour enregistrer les preuves du connecteur Exchange.",
  "submitReport": "Envoyer le rapport",
  "groupDns": "DNS",
  "groupM365": "Microsoft 365",
  "groupGoogle": "Google Workspace",
  "groupMailPath": "Chemin de messagerie",
  "noteDns": "Vérifié depuis ici, contre le DNS public via DNS-over-HTTPS. Ce sont les contrôles que la plateforme peut réellement effectuer seule.",
  "noteM365": "Les connecteurs Exchange et les règles de transport n’ont pas d’API Graph, et cette version n’a aucun client Graph. Chaque réponse de ce groupe provient d’un rapport Test-TenantMailFlow.ps1 collé par un opérateur.",
  "noteGoogle": "L’intégration Google Workspace n’existe pas encore dans ce code. Ces lignes sont là pour rendre cette absence visible plutôt que silencieuse — aucune ne réussira tant que l’intégration n’est pas construite.",
  "noteMailPath": "La plateforme qui se contrôle elle-même : son propre écouteur, ses propres certificats, sa propre livraison d’instantanés.",
  "loopbackBlocking": "La boucle locale du smart host échoue. Corrigez cela avant de passer à l’échelle de l’organisation — le courrier sortant rebondirait.",
  "loopbackTitle": "Le smart host résout vers la boucle locale",
  "checkedAge": "Vérifié il y a {{age}}.",
  "checksFailedTitle": "{{count}} contrôles ont échoué",
  "checksFailedBody": "Un contrôle en échec signifie que le chemin de messagerie de ce locataire est mal configuré maintenant, pas qu’il pourrait l’être plus tard. N’utilisez Ignorer sur une ligne que lorsque l’échec est un bruit connu pour ce locataire.",
  "checksSkippedTitle": "{{count}} contrôles n’ont pas été exécutés",
  "checksSkippedBody": "Ce locataire n’est pas vérifié. Les contrôles ci-dessous marqués « non exécuté » n’ont aucun résultat — ils ne réussissent pas en silence, et leur absence ne signifie rien d’autre que personne n’a regardé.",
  "ignore": "Ignorer",
  "unignore": "Ne plus ignorer",
  "sourceAutomated": "Automatisé",
  "sourcePasted": "Rapport collé",
  "sourceServer": "Serveur",
  "sourceUnknown": "Inconnu",
  "provenancePasted": "collé",
  "provenanceSkipped": "omis lors d’une exécution",
  "provenanceChecked": "vérifié",
  "groupNothingRan": "Rien dans ce groupe n’a été vérifié. Ces lignes ne réussissent pas en silence — elles n’ont jamais été exécutées.",
  "groupNoResults": "Pas encore de résultats. Lancez ce groupe, ou collez un rapport qui le couvre.",
  "tookMs": "A pris {{ms}} ms.",
  "ignoreHintFail": "Retire cet échec des totaux et des portes. Survécu aux réexécutions.",
  "ignoreHintWarn": "Retire cet avertissement des totaux et des portes. Survécu aux réexécutions.",
  "pasteTitle": "Coller un rapport Test-TenantMailFlow",
  "pasteIntro": "Préférez Lancer la validation automatisée ci-dessus lorsque l’application connecteur peut atteindre Exchange. Coller reste le recours d’urgence : exécutez ceci dans une session Exchange Online connectée au client, puis collez le JSON affiché.",
  "scriptTitle": "Test-TenantMailFlow.ps1",
  "scriptDescription": "En lecture seule. Interroge le DNS public en direct via DNS-over-HTTPS plutôt que le résolveur de la machine, pour qu’une réponse à horizon partagé ne paraisse pas rassurante.",
  "reportJson": "JSON du rapport",
  "reportJsonDescription": "Tout, de l’accolade ouvrante à l’accolade fermante.",
  "reportJsonPlaceholder": "{ \"Organization\": \"contoso.onmicrosoft.com\", \"Checks\": [ ... ] }",
  "reportInvalidTitle": "Ce rapport ne peut pas être classé",
  "reportCompleteTitle": "Le rapport semble complet",
  "reportSummary": "{{checks}} contrôles de {{organization}}, exécutés {{when}} : {{pass}} réussis, {{warn}} avertissements, {{fail}} échecs, {{skip}} non exécutés.",
  "fileError": "Impossible de classer le rapport",
  "fileReport": "Classer ce rapport",
  "filed": "Rapport classé pour ce locataire.",
  "filePermissionHint": "Un rapport classé devient la preuve de ce locataire, aussi les administrateurs du locataire et au-dessus peuvent en classer un. Exécuter la commande et lire la sortie ne nécessite aucun rôle.",
  "historyWhen": "Quand",
  "historySource": "Source",
  "historyResult": "Résultat",
  "historyEmpty": "Ce locataire n’a jamais été testé.",
  "historyPass": "{{count}} réussis",
  "historyWarn": "{{count}} avertissements",
  "historyFail": "{{count}} échecs",
  "historySkip": "{{count}} non exécutés"
}
